import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IProjectName } from '../types/IProject';

export interface IGetProjectNamesResult extends IGetItemsResult {
  projects: IProjectName[];
}

export class GetProjectNamesRequest extends Request<IGetItemsParams, IGetProjectNamesResult> {
  constructor(params: IGetItemsParams) {
    super('getProjectNames', params);
  }
}
